<template>
    <a class="nav-websocket-connection-btn btn"
       @click.prevent="click">
        <template v-if="connected && !!authenticatedBranchID">
            <i class="fa-solid fa-wifi fa-fw text-success"></i>
        </template>
        <template v-else-if="connected">
            <i class="fa-solid fa-wifi-exclamation fa-fw text-warning"></i>
        </template>
        <template v-else>
            <i class="fa-solid fa-wifi-slash fa-fw text-danger"></i>
        </template>
    </a>
</template>

<script>
import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState('websocket', ['connected', 'authenticatedBranchID']),
    },

    methods: {
        click() {
            // Do nothing.
        },
    },
};
</script>

<style lang="less">
@import (less, reference) "../../../less/colours.less";

.nav-websocket-connection-btn {
    min-width: 0 !important;
    background: none;
    border: none;
    cursor: default;

    i {
        margin: 0 !important;
    }
}
</style>
